<div class="qr-scanner-modal-container">
  <!-- Header with title, flashlight and close buttons -->
  <div class="scanner-header">
    <div class="header-left">
      <button type="button" class="icon-btn" [class.active]="isFlashlightOn()" (click)="toggleFlashlight()" aria-label="Toggle Flashlight">
        <span class="material-symbols-outlined" aria-hidden="true">{{ isFlashlightOn() ? 'flashlight_on' : 'flashlight_off' }}</span>
      </button>
    </div>

    <h2 class="scanner-title">Scan QR Code</h2>

    <div class="header-right">
      <button type="button" class="icon-btn close-btn" (click)="dismiss()" aria-label="Close Scanner">
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </div>
  </div>

  <!-- Viewfinder Viewport -->
  <div class="scanner-viewport">
    <div class="camera-backdrop">
      <!-- Crosshairs / Reticle Frame -->
      <div class="reticle-box" [class.success]="scanStatus() === 'success'">
        <span class="corner top-left"></span>
        <span class="corner top-right"></span>
        <span class="corner bottom-left"></span>
        <span class="corner bottom-right"></span>

        <!-- Animated Laser Scanning Beam -->
        <div class="laser-beam" *ngIf="scanStatus() === 'scanning'" aria-hidden="true"></div>

        <div class="success-icon-wrap" *ngIf="scanStatus() === 'success'">
          <span class="material-symbols-outlined success-icon">check_circle</span>
        </div>
      </div>
    </div>

    <p class="scanner-instruction">Align QR code inside the frame to scan automatically</p>
  </div>

  <!-- Manual Entry Toggle -->
  <div class="scanner-actions">
    <div class="manual-entry-section" *ngIf="isManualEntryOpen()">
      <div class="input-row">
        <input
          type="text"
          class="manual-code-input"
          placeholder="Enter QR / Store Code"
          [value]="manualCodeInput()"
          (input)="manualCodeInput.set($any($event.target).value)"
          (keyup.enter)="submitManualCode()"
          autofocus />
        <button type="button" class="action-submit-btn" (click)="submitManualCode()">Submit</button>
      </div>
    </div>

    <div class="action-buttons-row">
      <button type="button" class="text-action-btn" (click)="toggleManualEntry()">
        <span class="material-symbols-outlined" aria-hidden="true">{{ isManualEntryOpen() ? 'qr_code_scanner' : 'keyboard' }}</span>
        <span>{{ isManualEntryOpen() ? 'Back to Scanner' : 'Enter Code Manually' }}</span>
      </button>
    </div>
  </div>
</div>
